import React from 'react';
import PropTypes from 'prop-types';
import {
  resolutionDate,
  checkReason,
  expiresSoon,
} from '../utilities/poaRequests';
import KeyValueList from './KeyValueList';

const formatResponse = (poaStatus, poaRequest, poaRequestSubmission) => {
  switch (poaStatus) {
    case 'declination':
      return (
        <>
          {poaRequest?.resolution?.accreditedIndividual?.fullName ||
            'Your organization'}{' '}
          declined this request on{' '}
          {resolutionDate(poaRequest?.resolution?.createdAt, poaStatus.id)}{' '}
          {checkReason(poaRequest)}
        </>
      );
    case 'acceptance':
      if (
        poaRequestSubmission === 'PENDING' ||
        poaRequestSubmission === 'FAILED'
      ) {
        return null;
      }
      return (
        <>
          {poaRequest?.resolution?.accreditedIndividual?.fullName ||
            'Your organization'}{' '}
          accepted this request on{' '}
          {resolutionDate(poaRequest?.resolution?.createdAt, poaStatus.id)}. We
          processed the request and representation has been established.
        </>
      );

    default:
      return null;
  }
};
const POADetailsColumn = ({ poaRequest, poaStatus }) => {
  const poaRequestSubmission =
    poaRequest?.powerOfAttorneyFormSubmission?.status;

  const response = formatResponse(poaStatus, poaRequest, poaRequestSubmission);

  const poaRequestMetaData = {
    'Requested organization': poaRequest?.powerOfAttorneyHolder?.name,
    ...(poaRequest?.createdAt && {
      'Preferred representative':
        poaRequest?.accreditedIndividual?.fullName || 'None selected',
    }),
    ...(poaRequest?.createdAt && {
      'Request submitted on': (
        <>
          {resolutionDate(poaRequest?.createdAt, poaStatus.id)}{' '}
          {expiresSoon(poaRequest.expiresAt)}
        </>
      ),
    }),
    ...(response && { Response: response }),
  };

  const showClaimantOverviewLink =
    poaStatus === 'acceptance' &&
    poaRequestSubmission !== 'PENDING' &&
    poaRequestSubmission !== 'FAILED';

  const claimantOverviewLabel =
    poaRequest?.powerOfAttorneyForm?.claimant?.name?.first &&
    poaRequest?.powerOfAttorneyForm?.claimant?.name?.last
      ? `Go to the claimant overview for ${poaRequest.powerOfAttorneyForm.claimant.name.last}, ${poaRequest.powerOfAttorneyForm.claimant.name.first}`
      : 'Go to the claimant overview';

  return (
    <>
      <KeyValueList data={poaRequestMetaData} />
      {showClaimantOverviewLink && (
        <va-link-action
          active
          href={`/representative/find-claimant/claimant-overview/${poaRequest.claimantId}`}
          text="Go to the claimant overview"
          label={claimantOverviewLabel}
        />
      )}
    </>
  );
};

POADetailsColumn.propTypes = {
  poaRequest: PropTypes.object,
  poaStatus: PropTypes.string,
};

export default POADetailsColumn;
